import { Helmet } from 'react-helmet';
import { getProxifiedUrl } from '@openclassrooms/images-cdn';
import browser from '../../../browser';
import getPageTitle from '../../services/getPageTitle';

const MetaGlobal = ({
  children = null,
  description = '',
  imageBackground = '',
  imageUrl = '',
  ogDescription = '',
  ogTitle = '',
  twitterDescription = '',
  twitterTitle = '',
  title,
  shouldNotIndex = false,
  isBusiness = false,
  translations = {
    twitterAccount: '@OpenClassrooms',
  },
  jsonLD = null,
}) => {
  const metaImageURL = imageUrl ? new URL(getProxifiedUrl(imageUrl, 450)) : null;

  if (metaImageURL && imageBackground) {
    metaImageURL.searchParams.append('bg', imageBackground.replace('#', ''));
  }

  const metaImage = metaImageURL ? metaImageURL.toString() : null;

  const descriptions = {
    general: description,
    og: ogDescription || description,
    twitter: twitterDescription || description,
  };

  return (
    <Helmet>
      <title>{getPageTitle(title, isBusiness)}</title>
      {descriptions.general && <meta name="description" content={descriptions.general} />}
      <meta property="og:site" content="OpenClassrooms" />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={browser.window.location.href.replace(browser.window.location.search, '')}
      />
      <meta property="og:title" content={ogTitle || title} />
      {metaImage && <meta property="og:image" content={metaImage} />}
      {descriptions.og && <meta property="og:description" content={descriptions.og} />}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content={translations.twitterAccount} />
      <meta name="twitter:title" content={twitterTitle || title} />
      {metaImage && <meta name="twitter:image" content={metaImage} />}
      {descriptions.twitter && <meta name="twitter:description" content={descriptions.twitter} />}
      {shouldNotIndex && <meta name="robots" content="noindex, nofollow" />}
      {jsonLD && <script type="application/ld+json">{JSON.stringify(jsonLD)}</script>}
      {children}
    </Helmet>
  );
};

export default MetaGlobal;
